import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ErrorWrapper from 'dpl/form/components/ErrorWrapper';
import { get, isEmpty } from 'dpl/shared/utils/object';
import {
  BREEDER_DASHBOARD_PATH,
  BREEDER_APPLICATIONS_PATH,
  BREEDER_MESSAGES_PATH,
  FOOTER_PATHS
} from 'dpl/shared/constants/urls';
import {
  ADOPTER_APPLICATION_ID,
  CONVERSATION_ID
} from 'dpl/constants/query_params';
import { parseQueryString } from 'dpl/util/queryString';

export default class UserAuthInviteForm extends Component {
  static propTypes = {
    handleFormSubmission: PropTypes.func.isRequired,
    isFormSubmitting: PropTypes.bool.isRequired,
    didFormSubmissionFail: PropTypes.bool.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    formErrors: PropTypes.object.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    formState: PropTypes.object.isRequired,
    handleFormFieldChange: PropTypes.func.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string
    }).isRequired,
    sessionData: PropTypes.shape({
      value: PropTypes.shape({
        user: PropTypes.shape({
          first_name: PropTypes.string
        })
      }).isRequired,
      meta: PropTypes.shape({
        isError: PropTypes.bool.isRequired
      }).isRequired
    }).isRequired
  };

  handleSubmit = e => {
    e.preventDefault();
    const {
      location: { search: queryParams }
    } = this.props;

    this.props.handleFormSubmission().then(() => {
      this.redirectByParams(queryParams);
    });
  };

  redirectByParams = query => {
    const parsedParams = parseQueryString(query);
    if (parsedParams && parsedParams[CONVERSATION_ID]) {
      window.location = `${BREEDER_MESSAGES_PATH}/${parsedParams[CONVERSATION_ID]}`;
    } else if (parsedParams && parsedParams[ADOPTER_APPLICATION_ID]) {
      window.location = `${BREEDER_APPLICATIONS_PATH}${query}`;
    } else {
      window.location = BREEDER_DASHBOARD_PATH;
    }
  };

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps = nextProps => {
    // when the invite endpoint returns an error it means the invite token has already been claimed
    // the user is likely signed in already so we try to redirect them to the right page immediately
    if (nextProps.sessionData.meta.isError) {
      const {
        location: { search }
      } = nextProps;
      this.redirectByParams(search);
    }
  };

  render() {
    const {
      isFormSubmitting,
      didFormSubmissionFail,
      formState,
      formErrors,
      handleFormFieldChange,
      sessionData
    } = this.props;

    const { TERMS, PRIVACY, BREEDER_ETHICS } = FOOTER_PATHS;

    const firstName = get(sessionData, 'value.user.first_name');

    return (
      <form className="UserAuthInviteForm" onSubmit={this.handleSubmit}>
        <h1 className="mb6 f6">
          Welcome to Good Dog{firstName ? `, ${firstName}` : ''}!{' '}
        </h1>
        <p className="mb10">
          Set your password to log in to your account and start using our
          software to manage your waitlist, breeding dogs, and more.
        </p>

        <div className="mb6">
          <label htmlFor="password">
            <p className="dark-gray mb2 f2">Password</p>
            <ErrorWrapper
              errors={formErrors.password}
              isShown={didFormSubmissionFail}
            >
              <input
                name="password"
                type="password"
                className="UserAuthResetPasswordForm__input w-100 br1 ba b--light-gray ph4 pv2"
                value={formState.password || ''}
                onChange={handleFormFieldChange}
                placeholder="6+ characters"
              />
            </ErrorWrapper>
          </label>
        </div>

        <div className="mb10">
          <label htmlFor="password_confirmation">
            <p className="dark-gray mb2 f2">Confirm Password</p>
            <ErrorWrapper
              errors={formErrors.password_confirmation}
              isShown={didFormSubmissionFail}
            >
              <input
                type="password"
                name="password_confirmation"
                className="UserAuthResetPasswordForm__input w-100 br1 ba b--light-gray ph4 pv2"
                value={formState.password_confirmation || ''}
                onChange={handleFormFieldChange}
              />
            </ErrorWrapper>
          </label>
        </div>

        <button
          type="submit"
          disabled={isFormSubmitting || !isEmpty(formErrors)}
          className={`button button--primary ph14 pv4 center ${
            isFormSubmitting ? 'button--loading' : ''
          }`}
        >
          Continue
        </button>

        <p className="mt8 tc mid-gray f2">
          By continuing, I agree to Good Dog&apos;s&nbsp;
          <a className="underline" href={BREEDER_ETHICS}>
            Breeder Code of Ethics
          </a>
          ,&nbsp;
          <a className="underline" href={TERMS}>
            Terms of Service
          </a>
          , and{' '}
          <a className="underline" href={PRIVACY}>
            Privacy Policy
          </a>
          .
        </p>
      </form>
    );
  }
}
